import React from 'react';
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Maestro de Taller Industrial',
    text: '"Por fin tengo guías de trabajo que cumplen con las normas. Antes adaptaba libros viejos durante horas. Ahora entro al taller con la ficha lista y los alumnos trabajan desde el minuto uno."'
  }, {
    name: 'Sofía C.',
    role: 'Profesora de Electrotecnia',
    text: '"Mis alumnos nunca entendían para qué servía la puesta a tierra. Con el Tomo 4 y el caso práctico, lo midieron ellos mismos y no se olvidaron más. Fue un antes y un después."'
  }, {
    name: 'Pablo A.',
    role: 'Docente de Taller Técnico',
    text: '"Los proyectos integradores me salvaron el cierre de año. Tenía 3 grupos distintos y necesitaba proyectos diferentes para cada uno. Ya los tenía todos listos con sus rúbricas. No inventé nada."'
  }, {
    name: 'Jorge D.',
    role: 'Instructor de Formación Profesional',
    text: '"El material es directo y al grano. La guía del egresado electricista es exactamente lo que los chicos necesitan para salir a trabajar y saber cobrar. Excelente inversión."'
  }, {
    name: 'Miguel R.',
    role: 'Profesor de Instalaciones Eléctricas',
    text: '"Las evaluaciones listas me devolvieron los domingos. Antes perdía horas armando exámenes, ahora imprimo y evalúo con criterios claros. El nivel de detalle es profesional."'
  }];
  return <section className="py-10 px-4 bg-brand-card" data-id="element-169">
      <div className="max-w-xl mx-auto" data-id="element-170">
        <h2 className="text-xl font-black text-center mb-8 text-white" data-id="element-171">
          ❤️ LO QUE DICEN TUS COLEGAS (INSTRUCTORES TÉCNICOS)
        </h2>
        <div className="flex flex-col gap-4" data-id="element-172">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-dark p-5 rounded-md border border-white/5" data-id="element-173">
              <p className="text-sm text-gray-300 italic mb-4 leading-relaxed" data-id="element-174">
                {t.text}
              </p>
              <div data-id="element-175">
                <p className="font-bold text-white text-sm" data-id="element-176">{t.name}</p>
                <p className="text-xs text-brand-accent" data-id="element-177">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}